
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { useLanguage } from "@/contexts/LanguageContext";
import { useNavigate } from "react-router-dom";
import { LayoutDashboard } from "lucide-react";

export const ClientDashboardCard = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  
  return (
    <Card className="bg-gradient-to-br from-primary/10 via-primary/5 to-card border-border shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
      <CardHeader>
        <CardTitle className="flex flex-col items-center text-center whitespace-nowrap">
          <LayoutDashboard className="h-6 w-6 text-primary mb-2" />
          <span>{t('clientDashboard')}</span>
        </CardTitle>
        <CardDescription className="text-center">
          {t('manageYourCampaigns')}
        </CardDescription>
      </CardHeader>
      <CardContent className="min-h-28">
        <p className="text-sm leading-relaxed text-center">
          {t('viewCampaignPerformance')}
        </p>
      </CardContent>
      <CardFooter>
        <Button 
          size="lg" 
          className="w-full bg-primary text-white hover:bg-primary/90 font-medium"
          onClick={() => navigate('/client-dashboard')}
        >
          {t('accessDashboard')}
        </Button>
      </CardFooter>
    </Card>
  );
};
